export default function getWrapperElement(selector) {
	let element = selector;

	if (typeof selector === 'string') {
		element = window.document.getElementById(selector);

		if (!element) {
			// try query selector to find element
			element = window.document.querySelector(selector);
		}
	}

	return element instanceof HTMLElement ? element : null;
}
